import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

type TestimonialSectionProps = {
  backgroundImage: string;
  quote: string;
  author: string;
  platform: string;
  platformLogo: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  };
};

const TestimonialSection: React.FC<TestimonialSectionProps> = ({
  backgroundImage,
  quote,
  author,
  platform,
  platformLogo,
}) => {
  return (
    <div
      className="relative w-full h-[650px] md:h-[760px] bg-cover bg-top py-[100px] px-10 z-10"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="relative z-10 flex items-end justify-end h-full text-white max-w-[1306px] w-full mx-auto">
        <div className="max-w-full md:max-w-[490px] w-full">
          <p className="text-[28px] md:text-[35px] font-medium text-center leading-[30px] md:leading-[42px]">
            {`“${quote}”`}
          </p>

          <div className="mt-[40px]">
            <p className="text-[28px] md:text-[32px] font-medium text-center">{author}</p>
            <p className="text-[20px] md:text-[24px] font-normal text-center">on</p>

            <Link href="https://ca.trustpilot.com/review/gearfocus.com" target="_blank" rel="noopener noreferrer">
              <Image
                src={platformLogo.src}
                alt={platformLogo.alt}
                width={platformLogo.width || 100}
                height={platformLogo.height || 100}
                loading="lazy"
                className="mx-auto w-auto h-12 md:h-auto mt-1"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;